import React from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import {  ParagraphSBold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';


interface BadgeProps {
  label: string;
  leftColor: string;
  rightColor: string;
}

const Badge = ({ label, leftColor, rightColor }: BadgeProps) => {



  return (
    <LinearGradient start={{ x: -1, y: -1 }}
      end={{ x: 1, y: 1 }} colors={[leftColor, rightColor]} style={{
        borderRadius:SPACING['sp-4'],
        maxWidth: '100%',
        paddingHorizontal: SPACING['sp-8'],
        paddingVertical:SPACING['sp-4']}} >
      <ParagraphSBold color={NEUTRAL_TEXT0} align={true}>{label}</ParagraphSBold>
    </LinearGradient>
  );
};

export default Badge;
